package com.ervasstudio.tracoemovimento.pages.cursos.signup

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.util.Res.MyColors.Lilas
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.Colors.White
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun PrimeiraEtapaSignUp(
    nome: String,
    sobrenome: String,
    email: String,
    onNomeChange: (nome: String) -> Unit,
    onSobrenomeChange: (sobrenome: String) -> Unit,
    onEmailChange: (email: String) -> Unit,
    externalError: String? = null,
    onContinuarClick: () -> Unit,
    isMobile: Boolean,
) {
    var nameError by remember { mutableStateOf<String?>(null) }
    var sobrenomeError by remember { mutableStateOf<String?>(null) }
    var emailError by remember { mutableStateOf<String?>(null) }
    var isContinuing by remember { mutableStateOf(false) }

    val emailRegex = "^[A-Za-z0-9+_.-]+@(.+)\$".toRegex()
    val alturaCampo = if (isMobile) 44.px else 48.px   // era 48.px fixo
    val fontErro = if (isMobile) 11.px else 12.px       // era 12.px fixo

    Input(
        type = InputType.Text,
        value = nome,
        onValueChange = {
            onNomeChange(it)
            if (nameError != null) nameError = null
        },
        placeholder = "Nome",
        modifier = inputModifier(alturaCampo).margin(bottom = if (nameError != null) 2.px else 12.px)
    )
    nameError?.let {
        SpanText(it, Modifier.color(Colors.Red).fontSize(fontErro).margin(bottom = 12.px).fontFamily("GothamBook"))
    }

    Input(
        type = InputType.Text,
        value = sobrenome,
        onValueChange = {
            onSobrenomeChange(it)
            if (sobrenomeError != null) sobrenomeError = null
        },
        placeholder = "Sobrenome",
        modifier = inputModifier(alturaCampo).margin(bottom = if (nameError != null) 2.px else 12.px)
    )
    sobrenomeError?.let {
        SpanText(it, Modifier.color(Colors.Red).fontSize(fontErro).margin(bottom = 12.px).fontFamily("GothamBook"))
    }

    Input(
        type = InputType.Email,
        value = email,
        onValueChange = {
            onEmailChange(it)
            if (emailError != null) emailError = null
        },
        placeholder = "exemplo@email.com",
        modifier = inputModifier(alturaCampo).margin(bottom = if (emailError != null || externalError != null) 2.px else 12.px)
    )
    (emailError ?: externalError)?.let {
        SpanText(it, Modifier.color(Colors.Red).fontSize(fontErro).margin(bottom = 12.px).fontFamily("GothamBook"))
    }

    Button(
        onClick = {
            if (isContinuing) return@Button
            var isValid = true

            if (!pareceNome(nome = nome)) {
                nameError = "Por favor, introduza um nome válido."
                isValid = false
            }
            if (!pareceNome(nome = sobrenome)) {
                sobrenomeError = "Por favor, introduza um sobrenome válido."
                isValid = false
            }

            val normalizedEmail = email.trim().lowercase()
            if (!normalizedEmail.matches(emailRegex)) {
                emailError = "Formato de e-mail inválido."
                isValid = false
            }

            if (isValid) {
                isContinuing = true
                onContinuarClick()
            }
        },
        modifier = Modifier
            .fillMaxWidth()
            .height(alturaCampo)   // era height(48.px)
            .borderRadius(24.px)
            .backgroundColor(Lilas)
            .styleModifier { property("border", "none") }
    ) {
        SpanText(
            if (isContinuing) "Continuando..." else "Continuar",
            Modifier.fontFamily("GothamBlack").fontSize(if (isMobile) 14.px else 16.px).color(White)   // era sem fontSize
        )
    }
}

fun pareceNome(nome: String): Boolean {
    val texto = nome.trim()
    return texto.length >= 3 && texto.all { it.isLetter() || it.isWhitespace() }
}

private fun inputModifier(altura: CSSSizeValue<CSSUnit.px> = 48.px) = Modifier
    .fillMaxWidth()
    .height(altura)   // era height(48.px) fixo
    .borderRadius(24.px)
    .border(1.px, LineStyle.Solid, Colors.Black)
    .padding(leftRight = 16.px)
    .styleModifier {
        property("outline", "none")
    }